import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/organization/hierarchy` — dal 04-11-2026 le pagine di «Risorse umane» stanno tutte sotto `/hr/`. L'indirizzo vecchio
 * resta come rinvio, coi suoi parametri, per i preferiti, i collegamenti salvati e quelli negli avvisi.
 */
export const Route = createFileRoute('/_app/organization/hierarchy')({
  beforeLoad: ({ search }) => { throw redirect({ to: '/hr/hierarchy', search: search as never, replace: true }); },
});
